module.exports = __webpack_public_path__ + "node_modules/icheck/skins/square/green.png?869a3a67";